const projectData = [
    {
        id: '1',
        name: 'New admin Design',
        startdate: '02/5/2019',
        status: 'Completed',
        team: require('@/assets/images/users/avatar-6.jpg'),
        progressvalue: 100,
        color: 'success'
    },
    {
        id: '2',
        name: 'Landing page Design',
        startdate: '04/6/2019',
        status: 'Pending',
        team: require('@/assets/images/users/avatar-1.jpg'),
        progressvalue: 78,
        color: 'primary'
    },
    {
        id: '3',
        name: 'Multipurpose Landing Template',
        startdate: '06/6/2019',
        status: 'Completed',
        team: require('@/assets/images/users/avatar-2.jpg'),
        progressvalue: 100,
        color: 'success'
    },
    {
        id: '4',
        name: 'Blog Template Design',
        startdate: '07/5/2019',
        status: 'Completed',
        team: require('@/assets/images/users/avatar-2.jpg'),
        progressvalue: 100,
        color: 'success'
    },
    {
        id: '5',
        name: 'Brand logo design',
        startdate: '08/6/2019',
        status: 'Pending',
        team: require('@/assets/images/users/avatar-6.jpg'),
        progressvalue: 54,
        color: 'primary'
    },
    {
        id: '6',
        name: 'Redesign - Landing page',
        startdate: '10/6/2019',
        status: 'Pending',
        team: require('@/assets/images/users/avatar-2.jpg'),
        progressvalue: 41,
        color: 'primary'
    },
    {
        id: '7',
        name: 'Redesign - Dashboard',
        startdate: '12/5/2019',
        status: 'Completed',
        team: require('@/assets/images/users/avatar-6.jpg'),
        progressvalue: 100,
        color: 'success'
    },
    {
        id: '8',
        name: 'Landing page Design',
        startdate: '13/6/2019',
        status: 'Pending',
        team: require('@/assets/images/users/avatar-2.jpg'),
        progressvalue: 84,
        color: 'primary'
    },
    {
        id: '9',
        name: 'Multipurpose Landing Template',
        startdate: '15/6/2019',
        status: 'Completed',
        team: require('@/assets/images/users/avatar-1.jpg'),
        progressvalue: 100,
        color: 'success'
    },
];

export { projectData };
